import Help from './Help.js'
import './Help.scss'
export default Help
